import homeIcon from '@/assets/images/svg/home_icon.svg';
import homeFocusedIcon from '@/assets/images/svg/home_focused_icon.svg';
import myAccountIcon from '@/assets/images/svg/my_account_icon.svg';
import myAccountFocusedIcon from '@/assets/images/svg/my_account_focused_icon.svg';
import myEchoIcon from '@/assets/images/svg/my_echo_icon.svg';
import myEchoCollapsedIcon from '@/assets/images/svg/my_echo_collapsed_icon.svg';
import echoChatsIcon from '@/assets/images/svg/echo_chats_icon.svg';
import echoChatsFocusedIcon from '@/assets/images/svg/echo_chats_focused_icon.svg';
import type { NavItemConfig } from './types';

// Fallbacks for missing variants
const myEchoFocusedIcon = myEchoIcon;

/**
 * Defines the navigation items for the sidebar.
 * Uses explicit asset icons from /assets/images/svg per SoC refactor.
 */
export const getNavItems = (isCollapsed: boolean): NavItemConfig[] => [
  {
    to: '/home',
    label: 'Explore',
    icon: homeIcon,
    focusedIcon: homeFocusedIcon,
    size: 20,
    collapsedIconSize: 21,
  },
  {
    to: '/account',
    label: 'My Account',
    icon: myAccountIcon,
    focusedIcon: myAccountFocusedIcon,
    size: 20,
    collapsedIconSize: 25,
  },
  {
    to: '/messages',
    label: 'Echo Chats',
    icon: echoChatsIcon,
    focusedIcon: echoChatsFocusedIcon,
    size: 20,
    collapsedIconSize: 20,
  },
  {
    to: '/my-echo',
    label: 'My Echo',
    icon: isCollapsed ? myEchoCollapsedIcon : myEchoIcon,
    focusedIcon: myEchoFocusedIcon,
    size: 26,
    collapsedIconSize: 48,
  },
];
